import * as React from 'react'
import clsx from 'clsx'
import { ColumnsType, Table, Tag, TableProps } from 'components/common'
import { price } from 'lib/str-formatter'

export interface LedgerSingleItem {
  key: string | number
  date: string
  number: string | number
  type: string
  amount?: number
  balance?: number
}
type InternalProps = TableProps<LedgerSingleItem>

export interface LedgerSingleItemTableProps
  extends Omit<
    InternalProps,
    'pagination' | 'columns' | 'sticky' | 'onChange' | 'onRow'
  > {
  dataSource: Array<LedgerSingleItem>
}

const columns: ColumnsType<LedgerSingleItem> = [
  {
    title: 'No.',
    dataIndex: 'number',
  },
  {
    title: '日付',
    dataIndex: 'date',
  },
  {
    title: '区分',
    dataIndex: 'type',
    render: (value: string) => {
      switch (value) {
        case '入金':
          return <Tag color="green">{value}</Tag>
        case '出金':
          return <Tag color="red">{value}</Tag>
        default:
          return <Tag color="yellow">{value}</Tag>
      }
    },
  },
  {
    title: '金額',
    dataIndex: 'amount',
    render: (value: number) => {
      if (value >= 0) return <span>{price(value)}</span>
      else return <span className="text-red-500">{price(value)}</span>
    },
  },
  {
    title: '残高',
    dataIndex: 'balance',
    render: (value: number) => {
      if (value >= 0) return <span>{price(value)}</span>
      else return <span className="text-red-500">{price(value)}</span>
    },
  },
]

export const LedgerSingleItemTable = ({
  dataSource,
  ...restProps
}: LedgerSingleItemTableProps): JSX.Element => {
  return (
    <Table
      sticky
      pagination={false}
      rowClassName={clsx('cursor-pointer')}
      dataSource={dataSource}
      columns={columns}
      {...restProps}
    />
  )
}
